import { render, staticRenderFns } from "./c-btn-new.vue?vue&type=template&id=43f8a62e&scoped=true"
import script from "./c-btn-new.vue?vue&type=script&lang=ts"
export * from "./c-btn-new.vue?vue&type=script&lang=ts"
import style0 from "./c-btn-new.vue?vue&type=style&index=0&id=43f8a62e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43f8a62e",
  null
  
)

export default component.exports